import React from "react"
import type { vehicleHistoryProps } from "../../interfaces/IDispacthVehicle";
import { Container, Divider, Grid, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useLang } from "~/hooks/useLang";

interface CrewCompositionFormProps {
  readonly dispatchedVehiclesPrintResponse: vehicleHistoryProps[];
}

export default function CrewCompositionForm({ dispatchedVehiclesPrintResponse }: CrewCompositionFormProps) {
  const { translate } = useLang();

  return (
    <Container fixed={false}>
      <Grid container xs={12} sx={{ marginBottom: 2 }}>
        {dispatchedVehiclesPrintResponse.length != 0 ? (
          dispatchedVehiclesPrintResponse.map((vehicle, index) => (
            <Grid
              container
              key={index.toString()}
              xs={12}
              sx={{
                margin: '8px 0',
                border: 1,
                borderStyle: 'dashed'
              }}>
              <Grid
                item
                xs={3}
                sx={{
                  border: 1,
                  borderStyle: 'dashed',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center'
                }}>
                <Typography
                  variant='subtitle1'>
                  <b>
                    {vehicle?.device?.name}
                  </b>
                  <br />
                  <Typography variant='subtitle2'>
                    {vehicle?.device?.vehicle?.plate ? `(${vehicle?.device?.vehicle?.plate})` : ''}
                  </Typography>
                </Typography>
              </Grid>
              <Grid
                container
                xs={9}
                padding={2}
              >
                {
                  vehicle['device_log'] && (
                    vehicle['device_log']['crew'].length && (
                      <Grid item xs={12}>
                        <Grid container xs={12}>
                          <Grid item xs={12}>
                            <Typography variant='subtitle1'>
                              <b>
                                {translate(vehicle.device.device_type.name)}
                              </b>
                            </Typography>
                            {
                              vehicle['device_log']['crew'].map((crew, crewIndex) => {
                                const crewPosition = crew.position;
                                const crewUser = crew.user;
                                const getPosition = {
                                  'Comandante': vehicle.device?.device_type?.label_commander ? vehicle.device?.device_type.label_commander : 'Comandante',
                                  'Motorista': vehicle.device?.device_type?.label_driver ? vehicle.device?.device_type.label_driver : 'Motorista',
                                  'Patrulheiro': vehicle.device?.device_type?.label_patrolmans ? vehicle.device?.device_type.label_patrolmans : 'Patrulheiro',
                                }

                                if (crewPosition?.name === 'Patrulheiro') {
                                  return null;
                                }

                                return (
                                  (crewPosition && crewUser) && (
                                    <Typography key={crewIndex.toString()} variant='subtitle2'>
                                      <b>
                                        {getPosition[crewPosition.name] ? `${getPosition[crewPosition.name]}: ` : `${crewPosition.name}: `}
                                      </b>
                                      {crewUser.registration && `[${crewUser.registration}] `}
                                      {crewUser.representation_name}
                                    </Typography>
                                  )
                                )
                              })
                            }
                            {
                              vehicle['device_log']['crew'].filter((item) => item.position.name === 'Patrulheiro').length > 0 && (
                                <Typography variant='subtitle2'>
                                  <b>
                                    {`${translate("Patrolman")}: `}
                                  </b>
                                  {vehicle['device_log']['crew']
                                    .filter((item) => item.position.name === 'Patrulheiro')
                                    .map((crew, crewIndex, array) => {
                                      const crewPosition = crew.position;
                                      const crewUser = crew.user;
                                      return (
                                        (crewPosition && crewUser) &&
                                        (`${crewUser.registration ? `[${crewUser.registration}] ` : ''}${crewUser.representation_name}${(array.length - 1) !== crewIndex ? ', ' : ''}`)
                                      )
                                    })}
                                </Typography>
                              )
                            }
                          </Grid>
                        </Grid>
                      </Grid>
                    )
                  )
                }
              </Grid>
            </Grid>
          ))
        ) : (
          <Grid item xs={12} textAlign={'center'}>
            <Typography variant='subtitle1'><b>{translate('NO INFORMATION REGISTERED')}</b></Typography>
          </Grid>
        )}
      </Grid>
    </Container>
  )
}